import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
  name: 'dateRangeFormat',
})
export class DateRangeFormatPipe implements PipeTransform {

  transform(
    startUtc: string | Date,
    endUtc: string | Date,
    dateFormat: string = 'dd-MMM-yyyy',
    timeFormat: string = 'hh:mm a',
    locale: string = 'en-US'
  ): string {

    if (!startUtc || !endUtc) return '';

    const start = this.parseUtc(startUtc);
    const end = this.parseUtc(endUtc);

    if (!start || !end) return '';

    const sameDay =
      start.getFullYear() === end.getFullYear() &&
      start.getMonth() === end.getMonth() &&
      start.getDate() === end.getDate();

    if (sameDay) {
      return `${formatDate(start, `${dateFormat} ${timeFormat}`, locale)} - ${formatDate(end, timeFormat, locale)}`;
    }

    return `${formatDate(start, `${dateFormat} ${timeFormat}`, locale)} - ${formatDate(end, `${dateFormat} ${timeFormat}`, locale)}`;
  }

  private parseUtc(date: string | Date): Date {
    if (typeof date === 'string') {
      if (!date.endsWith('Z') && !date.includes('+')) {
        return new Date(date + 'Z');
      }
      return new Date(date);
    }
    return new Date(date);
  }
}
